module.exports = __webpack_public_path__ + "static/main_background-6647b2e82d3b1e9fd68f04453d7d7686.png";